// Ramadan 2026: 18. Februar Abend (Maghrib) bis 19. März 00:00
// Start: 18.02.2026 um 18:00 (Maghrib Zeit)
// Ende: 19.03.2026 um 00:00
export const RAMADAN_START = new Date(2026, 1, 18, 18, 0, 0);
export const RAMADAN_END = new Date(2026, 2, 19, 0, 0, 0);

// Eid al-Fitr 2026: 20. März
export const EID_DATE = new Date(2026, 2, 20);

// Hilfsfunktion: Lokales Datum als String (YYYY-MM-DD)
export const getLocalDateString = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Funktion um basierend auf dem Datum den Index der Tat zu bestimmen
// Verwendet einen besseren Hash-Algorithmus für mehr Variation
export const getDeedIndexForDate = (date, deedsLength) => {
  // Verwende Datum-String für konsistenten Hash
  const dateStr = getLocalDateString(date);
  
  // Einfacher aber effektiver Hash
  let hash = 0;
  for (let i = 0; i < dateStr.length; i++) {
    const char = dateStr.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  
  // Stelle sicher, dass das Ergebnis positiv ist
  return Math.abs(hash) % deedsLength;
};

// App-Tag berechnen - wechselt um Mitternacht (00:00 lokale Zeit)
export const getAppDay = () => {
  return getLocalDateString();
};

// Aktuelles Datum für die ANZEIGE (immer das lokale Datum)
export const getCurrentDisplayDate = () => {
  return getLocalDateString();
};

// Prüfen ob aktuell Ramadan ist
export const isRamadanPeriod = () => {
  const now = new Date();
  return now >= RAMADAN_START && now <= RAMADAN_END;
};

// Ramadan-Tag berechnen (1-30)
// Tag 1 = erster Fastentag (19. Feb), da Ramadan am Abend des 18. Feb beginnt
export const getRamadanDay = () => {
  const now = new Date();
  if (now < RAMADAN_START || now > RAMADAN_END) return 0;
  
  // Erster Fastentag ist der Tag NACH dem Maghrib-Start
  const firstFastingDay = new Date(2026, 1, 19, 0, 0, 0);
  
  const currentDate = new Date(now);
  currentDate.setHours(0, 0, 0, 0);
  
  const diffTime = currentDate - firstFastingDay;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
  
  // Am Abend des 18. Feb (vor Mitternacht) ist es noch Tag 0 → clamp to 1
  return Math.min(Math.max(diffDays, 1), 30);
};

// Deed-Index für Ramadan (ab 19. Feb = Index 0)
export const getRamadanDeedIndex = () => {
  const now = new Date();
  if (now < RAMADAN_START || now > RAMADAN_END) return 0;
  
  const firstFastingDay = new Date(2026, 1, 19, 0, 0, 0);
  
  const currentDate = new Date(now);
  currentDate.setHours(0, 0, 0, 0);
  
  const diffTime = currentDate - firstFastingDay;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  
  return Math.min(Math.max(diffDays, 0), 29);
};

// Islamisches Datum für Ramadan berechnen
// 1. Ramadan 1447 H = 19. Februar 2026
export const getIslamicDate = (ramadanDay) => {
  if (ramadanDay <= 0 || ramadanDay > 30) return null;
  return { day: ramadanDay, month: 'Ramadan', year: 1447 };
};

// Prüfen ob heute Eid al-Fitr ist (20.03.2026)
export const isEidDay = () => {
  const now = new Date();
  const eidDate = new Date(EID_DATE);
  return now.getFullYear() === eidDate.getFullYear() &&
         now.getMonth() === eidDate.getMonth() &&
         now.getDate() === eidDate.getDate();
};
